import { RULES, ruleStatus, strength, STRENGTH_META } from "@/lib/passwordPolicy";
import { Check, X } from "lucide-react";
import { cn } from "@/lib/util";

/**
 * Real-time password strength meter with a bar + per-rule checklist.
 * Used by the create/edit user modal and any future password reset flow.
 */
export function PasswordStrengthMeter({ password, showRulesAlways = true }) {
  const empty = !password;
  const s = strength(password);
  const meta = STRENGTH_META[s];
  const status = ruleStatus(password);

  return (
    <div className="mt-2" data-testid="password-strength-meter">
      {/* Segmented bar (5 blocks representing the 4 levels + zero) */}
      <div className="flex gap-1" aria-hidden="true">
        {[0, 1, 2, 3, 4].map((i) => (
          <div key={i}
               className="h-1.5 flex-1 border border-border transition-colors"
               style={{ backgroundColor: !empty && s >= i ? meta.color : "transparent" }} />
        ))}
      </div>
      <div className="mt-1 flex items-center justify-between font-mono text-[10px] tracking-widest uppercase">
        <span className="text-muted-foreground">Fortaleza</span>
        <span data-testid="password-strength-label" style={{ color: empty ? "#71717a" : meta.color }}>
          {empty ? "—" : meta.label}
        </span>
      </div>

      {(showRulesAlways || !empty) && (
        <ul className="mt-3 grid grid-cols-1 gap-1" data-testid="password-rules-checklist">
          {RULES.map((r) => {
            const passed = status[r.id];
            return (
              <li key={r.id}
                  data-testid={`pw-rule-${r.id}`}
                  data-passed={passed ? "true" : "false"}
                  className={cn("flex items-center gap-2 text-[10px] font-mono",
                    passed ? "text-sev-low" : "text-muted-foreground")}>
                {passed
                  ? <Check className="w-3 h-3 shrink-0" />
                  : <X className="w-3 h-3 shrink-0 text-muted-foreground/60" />}
                <span>{r.label}</span>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
